<template>
  <div class="add">
    <!-- <add-ut /> -->
    <ui-loading-circle :descText="'downloadingDot'" :applyBackground="true" v-if="!isLoaded"/>
    <h1>
      <span @click="$router.go(-1)"></span>
      {{title}}
    </h1>
    <div class="question-content">
      <input-text
        :title="'테스트 제목'"
        :baseText="'테스트 제목을 입력해주세요.'"
        :contList="modelError.testName ? 'error' : ''"
        :errorText="modelError.testName"
        :modelValue="model.testName"
        @input="getTestTitle" />

      <input-text
        :title="'담당자 연락'"
        :baseText="'테스트에 공개되는 담당자 연락처(이메일 or 전화번호)를 입력해주세요.'"
        :contList="modelError.contact ? 'error' : ''"
        :errorText="modelError.contact"
        :modelValue="model.contact"
        @input="getContact" />

      <input-text
        :title="'테스트 시작 지정 URL'"
        :baseText="'테스트 세션을 시작할 URL을 입력해주세요.'"
        :contList="modelError.url ? 'error' : ''"
        :errorText="modelError.url"
        :modelValue="model.url"
        @input="getUrl"/>
      <!-- editor 기능 추가 -->
      <!-- <input-text
        :title="'테스트 내용'" :baseText="'테스트 내용을 입력해주세요.'" class="editor"
        :contList="modelError.contents ? 'error' : ''"
        :errorText="modelError.contents"
        :modelValue="model.contents"
        @input="getContents"/> -->

      <tip-tap v-model="model.contents" :title="'테스트 내용'" :placeholder="'테스트 내용을 입력해주세요.'" :limit="60000"
               :errorText="modelError.contents" />

      <h2>문항 생성</h2>
      <div class="question-list">
        <template v-for="(question, index) in model.surveyInfo.question">
          <div class="question-con" v-bind:key="index">
            <h3>{{index+1}}.</h3>
            <div class="question-list-del" @click="onDeleteQuestion(index)">문항삭제</div>
            <input-text
              :title="'질문'"
              :baseText="'테스트 제목을 입력해주세요.'"
              :modelValue="question.subject"
              @input="getQuestionSubject"
              :index="index"
              :contList="modelError.surveyInfo.question[index].subject ? 'error' : ''"
              :errorText="modelError.surveyInfo.question[index].subject"
            />
            <ui-select :title="'문항 타입'" :itemList="utItemTypeList" :modelValue="question.itemType" @input="getQuestionItemType" :index="index" />

            <template v-for="(item , itemIndex) in question.items">
              <div v-bind:key="itemIndex">
                <span>
                  <input-text :title="'항목 리스트 ' + (itemIndex+1)" :baseText="'문항내용을 입력해주세요'"
                              :modelValue="item" @input="getQuestionItems"
                              :parentIndex="index"
                              :index="itemIndex"
                              :contList="modelError.surveyInfo.question[index].items[itemIndex] ? 'sublist error' : 'sublist'"
                              :errorText="modelError.surveyInfo.question[index].items[itemIndex]"
                  />
                  <ui-icon :iconStyle="'del'" v-if="itemIndex !== 0" @click="onDeleteQuestionItem(itemIndex, index)"/>
                  <ui-icon :iconStyle="'plus'" v-if="question.items.length-1 === itemIndex" @click="onAddQuestionItem(index)"/>
                </span>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="question-plus-btn" @click="onAddQuestion">
        <img src="@/assets/images/icon-question-plus.svg" alt="">문항추가
      </div>
      <div class="agreement">
        <h5>
          개인정보 수집 및 이용 동의
          <div class="tooltip-wrap">
            <img src="@/assets/images/icon-card-tooltip.svg" alt="">
            <div class="tooltip-text">
              빈 값일 경우, 기본 양식을 사용합니다.
            </div>
          </div>
          <span @click="onClickTermsDefault('privacy')">기본양식 가져오기</span>
        </h5>
        <textarea class="agreement-text" v-model="model.terms1">
        </textarea>
      </div>
      <div class="agreement mT50">
        <h5>
          제 3자 정보제공 동의
          <div class="tooltip-wrap">
            <img src="@/assets/images/icon-card-tooltip.svg" alt="">
            <div class="tooltip-text">
              빈 값일 경우, 기본 양식을 사용합니다.
            </div>
          </div>
          <span @click="onClickTermsDefault('third')">기본양식 가져오기</span>
        </h5>
        <textarea class="agreement-text" v-model="model.terms2">
        </textarea>
      </div>
    </div>
    <div class="btn-clear-position">
      <!-- :btnClass="'question-clear-on'" = on 유무 커튼 활성화 -->
      <button-item :btnText="isEdit ? '설문 수정 완료' : '설문 생성 완료'" :btnClass="'question-clear on'" @click="onSubmit"/>
    </div>

  </div>
</template>

<script>
import { create } from 'vue-modal-dialogs'
import { isValidUrl } from '@/libs/validation-helper'
import InputText from '@/components/ui/InputText'
import UiSelect from '@/components/ui/UiSelect'
import ButtonItem from '@/components/ui/button'
import UiIcon from '@/components/ui/UiIcon'
import TipTap from '@/components/editor/TipTap'
import StylePattern from '@/components/layerpop/StylePattern'

import PRIVACY_DEFAULT from '@/assets/text/privacy.txt'
import THIRD_DEFAULT from '@/assets/text/third.txt'

import { ERROR_MSG, UT_ITEM_TYPE_LIST } from '@/libs/constants'
import { imageUpload, saveUt } from '@/api/ut'

const termsConfirmLayer = create(StylePattern)

const newItem = {
  subject: '',
  itemType: 'radio',
  items: [
    '',
    ''
  ]
}

export default {
  name: 'Dashboard',
  components: {
    InputText,
    UiSelect,
    ButtonItem,
    UiIcon,
    TipTap
  },
  props: [
    'data'
  ],
  data () {
    return {
      isLoaded: false,
      isEdit: false,
      model: {
        contact: '',
        testName: '',
        contents: '',
        url: '',
        surveyInfo: {
          question: []
        },
        terms1: PRIVACY_DEFAULT,
        terms2: THIRD_DEFAULT
      },
      modelError: {
        contact: '',
        testName: '',
        contents: '',
        url: '',
        surveyInfo: {
          question: []
        }
      },
      utItemTypeList: UT_ITEM_TYPE_LIST,
      title: 'UT 등록'
    }
  },
  mounted () {
    document.documentElement.scrollTo(0, 0)
  },
  created () {
    this.onAddQuestion()
    if (this.data) {
      this.isEdit = true
      this.title = 'UT 수정하기'
      this.isLoaded = false
      this.setDataForEdit()
    } else {
      this.isLoaded = true
    }
  },
  computed: {
    canSubmit () {
      return this.model.testName.length && this.model.contact.length && this.model.contents.length && this.model.url.length && isValidUrl(this.model.url)
    }
  },
  methods: {
    async onClickTermsDefault (type) {
      if (await termsConfirmLayer()) {
        if (type === 'privacy') {
          this.model.terms1 = PRIVACY_DEFAULT
        } else {
          this.model.terms2 = THIRD_DEFAULT
        }
      }
    },
    setDataForEdit () {
      this.model = this.data

      const questionList = this.data.surveyInfo.question
      if (questionList.length > 0) {
        for (let i = 0, iLen = questionList.length; i < iLen; i++) {
          this.modelError.surveyInfo.question.push(JSON.parse(JSON.stringify(newItem)))
        }
      }
      this.isLoaded = true
    },
    checkQuestionValidate () {
      let bResult = true
      const list = this.model.surveyInfo.question
      for (let i = 0, iLen = list.length; i < iLen; i++) {
        const question = list[i]
        const subject = question.subject
        if (!subject) {
          bResult = false
          this.modelError.surveyInfo.question[i].subject = ERROR_MSG.question.subject.empty
        }
        const items = question.items
        for (let j = 0, jLen = items.length; j < jLen; j++) {
          const item = items[j]
          if (!item) {
            bResult = false
            this.modelError.surveyInfo.question[i].items[j] = ERROR_MSG.question.item.empty
          }
        }
      }
      return bResult
    },
    onAddQuestionItem (parentIndex) {
      this.model.surveyInfo.question[parentIndex].items.push('')
      this.modelError.surveyInfo.question[parentIndex].items.push('')
    },
    onDeleteQuestionItem (index, parentIndex) {
      this.model.surveyInfo.question[parentIndex].items.splice(index, 1)
      this.modelError.surveyInfo.question[parentIndex].items.splice(index, 1)
    },
    onAddQuestion () {
      this.model.surveyInfo.question.push(JSON.parse(JSON.stringify(newItem)))
      this.modelError.surveyInfo.question.push(JSON.parse(JSON.stringify(newItem)))
    },
    onDeleteQuestion (index) {
      this.model.surveyInfo.question.splice(index, 1)
      this.modelError.surveyInfo.question.splice(index, 1)
    },
    getQuestionSubject (value, index) {
      this.model.surveyInfo.question[index].subject = value
    },
    getQuestionItemType (item, index) {
      this.model.surveyInfo.question[index].itemType = item.value
    },
    getQuestionItems (value, index, parentIndex) {
      this.model.surveyInfo.question[parentIndex].items[index] = value
    },
    getTestTitle (value) {
      this.model.testName = value
    },
    getContact (value) {
      this.model.contact = value
    },
    getUrl (value) {
      this.model.url = value
    },
    getContents (value) {
      this.model.contents = value
    },
    validationReset () {
      this.modelError.testName = ''
      this.modelError.contact = ''
      this.modelError.url = ''
      this.modelError.contents = ''

      const list = this.model.surveyInfo.question
      for (let i = 0, iLen = list.length; i < iLen; i++) {
        const question = list[i]
        this.modelError.surveyInfo.question[i].subject = ''
        const items = question.items
        for (let j = 0, jLen = items.length; j < jLen; j++) {
          this.modelError.surveyInfo.question[i].items[j] = ''
        }
      }
    },
    async base64ImageUpload () {
      const content = document.querySelector('.ProseMirror')
      const imgList = content.querySelectorAll('img')
      for (let i = 0, iLen = imgList.length; i < iLen; i++) {
        const imgElem = imgList[i]
        let image = imgElem.getAttribute('src')

        if (image.indexOf('data:image/') > -1 && image.indexOf('base64') > -1) {
          const uploadResult = await imageUpload({ type: 'base64', upload: image })
          const uploadUrl = uploadResult.result.url
          this.model.contents = this.model.contents.replace(image, uploadUrl)
        }
      }
    },
    async onSubmit () {
      this.validationReset()

      let validation = true

      if (!this.canSubmit) {
        if (!this.model.testName.length) {
          this.modelError.testName = ERROR_MSG.testName.empty
        }
        if (!this.model.contact.length) {
          this.modelError.contact = ERROR_MSG.contact.empty
        }
        if (!this.model.url.length) {
          this.modelError.url = ERROR_MSG.url.empty
        } else {
          if (!isValidUrl(this.model.url)) {
            this.modelError.url = ERROR_MSG.url.unable
          }
        }

        if (!this.model.contents.length) {
          this.modelError.contents = ERROR_MSG.contents.empty
        }
        validation = false
      }

      if (!this.checkQuestionValidate()) {
        console.log(this.checkQuestionValidate())
        validation = false
      }

      if (!validation) return

      await this.base64ImageUpload()

      const params = JSON.parse(JSON.stringify(this.model))

      if (params.terms1 === '') {
        params.terms1 = PRIVACY_DEFAULT
      }
      if (params.terms2 === '') {
        params.terms2 = THIRD_DEFAULT
      }

      this.isLoaded = false
      saveUt(params).then(data => {
        this.isLoaded = true
        this.$router.push({ name: 'dashboard' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add {
  margin: 90px auto 0;
  padding-bottom: 160px;
  & > h1 {
    width: 990px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    margin: 0 auto;
    & span {
      display: inline-block;
      width: 32px;
      height: 32px;
      vertical-align: middle;
      border-radius: 5px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
      background: #fff url('../../../assets/images/icon-page-back.svg') no-repeat center;
      margin-right: 20px;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background: #f7f7f7 url('../../../assets/images/icon-page-back.svg') no-repeat center;
      }
    }
  }

  .question-content {
    width: 990px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.10), 0 0 0 1px rgba(0, 0, 0, 0.10);
    background: #fff;
    padding: 60px 60px 70px;
    box-sizing: border-box;
    margin: 15px auto 0;

    h2 {
      font-size: 20px;
      font-weight: 500;
      line-height: 1;
      color: #444;
      text-align: center;
    }

    .question-list {
      position: relative;
      border-radius: 12px;
      border: solid 2px #dfcf9c;
      background-color: #fcf9eb;
      padding: 0px 30px;
      box-sizing: border-box;
      margin-top: 20px;
      .question-con {
        position: relative;
        margin: 40px 0 20px;
      }
      h3 {
        font-size: 20px;
        font-weight: 500;
        color: #444;
        margin-bottom: 20px;
      }
      .question-list-del {
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 14px;
        font-weight: 500;
        color: #444;
        background: url('../../../assets/images/icon-question-close.svg') no-repeat left center;
        padding-left: 20px;
        cursor: pointer;
      }
      span {
        display: block;
        position: relative;
      }
    }

    .question-plus-btn {
      width: 100%;
      height: 50px;
      border-radius: 12px;
      border: dotted 2px #dfcf9c;
      background-color: #fcf9eb;
      border-style: dashed;
      text-align: center;
      line-height: 50px;
      margin-top: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #444;
      cursor: pointer;
      box-sizing: border-box;
      img {
        vertical-align: middle;
        margin: -4px 5px 0 0;
      }
    }

    .agreement {
      margin-top: 70px;
      h5 {
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        font-weight: 500;
        color: #767676;
        .tooltip-wrap {
          position: relative;
          display: inline-block;
          img {
            margin: -5px 0 0 5px;
            vertical-align: middle;
          }
          .tooltip-text {
            display: none;
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-49%);
            width: 245px;
            height: 50px;
            box-sizing: border-box;
            line-height: 1.50;
            text-align: center;
            padding: 15px 20px;
            box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
            background: #fff;
            border-radius: 10px;
            letter-spacing: -1px;
             &::after {
              content: "";
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              border-width: 5px;
              border-style: solid;
              border-color: #fff transparent transparent transparent;
            }
            &::before {
              content: "";
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              border-width: 7px;
              border-style: solid;
              border-color: rgba(0, 0, 0, 0.16) transparent transparent transparent;
            }
          }
          &:hover {
            .tooltip-text {
              display: block;
            }
          }
        }
        span {
          background: url('../../../assets/images/icon-agreement-down.svg') no-repeat left center;
          float: right;
          text-align: right;
          color: #1990c2;
          cursor: pointer;
          padding-left: 20px;
        }
      }
      .agreement-text {
        width: 100%;
        height: 200px;
        overflow-y: auto;
        margin-top: 15px;
        border-radius: 6px;
        border: solid 1px #bbb;
        background: #fff;
        padding: 17px 20px 20px;
        font-size: 14px;
        line-height: 1.57;
        box-sizing: border-box;
        color: #333;
        outline: none;
        resize: none;
      }
      &.mT50 {
        margin-top: 50px;
      }
    }
  }
  .btn-clear-position {
    text-align: center;
    margin-top: 40px;
  }

}

@media all and (max-width: 990px) {
  .add {
      min-width: 768px;

      & > h1 {
          width: calc(100% - 40px);
      }
      .question-content {
          position: relative;
          width: calc(100% - 40px);
          height: auto;
      }
  }
}
</style>
